import { render, staticRenderFns } from "./DataCenterTableMicro.vue?vue&type=template&id=5977fed4"
import script from "./DataCenterTableMicro.vue?vue&type=script&lang=js"
export * from "./DataCenterTableMicro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports